// Angular Imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import { ShopTranslationsOdooService } from './services/shop-translations-odoo.service';
import { ShopTranslationsService } from './services/shop-translations.service';

const ShopTranslationsServiceClass = environment.production ? ShopTranslationsOdooService : ShopTranslationsService;

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
    ],
    declarations: [
      ],
    exports: [
    ],
    providers: [
      [{ provide: ShopTranslationsService, useClass: ShopTranslationsServiceClass }],
    ],
    entryComponents: [
    ]
})
export class TranslationsModule {

}
